const { autoSliderIntervalIds } = require('./common/carousel');

const loaderAnimate = {
  dom: {},
  CHECK_GENERATE_TIMING: 60,
  settings: {
    animationTiming: null,
  },
  init() {
    window.timerIds.forEach(id => clearInterval(id));
    window.timerIds = [];
    refreshDomWindowElements();
    try {
      document.body.classList.add(store.getAnswers().bodyClass || store.get('bodyClass') || 'woman-theme');
    } catch (e) {
      document.body.classList.add('woman-theme');
    }

    const spinningTextsFirstExcluded = [...window.spinningTexts].slice(-(window.spinningTexts.length - 1));
    this.dom = {
      slider: window.slider,
      spinningTexts: window.spinningTexts,
      spinningTextsFirstExcluded,
    };

    this.percentsLoader();
    this.setSlidingContainerToInitialPoint();
    this.startSpinningAllTexts();
  },
  startSpinningAllTexts() {
    let current = 0;
    [...this.dom.spinningTextsFirstExcluded].forEach((spin, index) => {
      const timeOutId = setTimeout(() => this.spinText(spin, index), this.settings.animationTiming * current);
      window.timerIds.push(timeOutId);
      current++;
    });
  },
  setSlidingContainerToInitialPoint() {
    const elementCenter = this.dom.spinningTextsFirstExcluded[0].offsetWidth / 2;
    const sliderCenter = window.slider.offsetWidth / 2;
    this.setSliderX(sliderCenter - elementCenter);
    this.settings.animationTiming = 10000 / this.dom.spinningTextsFirstExcluded.length;
  },
  getTranslateX(element) {
    const style = window.getComputedStyle(element);
    const matrix = new WebKitCSSMatrix(style.webkitTransform);
    return matrix.m41;
  },
  setSliderX(value) {
    window.slider.style.transform = `translateX(${value}px)`;
  },
  spinText() {
    this.dom.slider.style.transition = `all ${this.settings.animationTiming}ms ease-in-out`;

    if (this.settings.currentActive === 0) this.dom.spinningTexts.classList.replace('active', 'pale');
    if (this.settings.currentActive === this.dom.spinningTextsFirstExcluded.length - 1) return;

    this.dom.spinningTextsFirstExcluded[window.currentActive - 1]?.classList.remove('active');
    this.dom.spinningTextsFirstExcluded[window.currentActive - 1]?.classList.add('pale');
    this.dom.spinningTextsFirstExcluded[window.currentActive]?.classList.replace('pale', 'active');
    this.dom.spinningTextsFirstExcluded[window.currentActive + 1]?.classList.remove('active');
    this.dom.spinningTextsFirstExcluded[window.currentActive + 1]?.classList.add('pale');
    window.currentActive++;

    const elementWidth = this.dom.spinningTextsFirstExcluded[0].offsetWidth;
    let moveToValue;
    if (document.dir === 'rtl') moveToValue = this.getTranslateX(this.dom.slider) + elementWidth;
    if (document.dir === 'ltr') moveToValue = this.getTranslateX(this.dom.slider) - elementWidth;
    this.setSliderX(moveToValue);
  },
  percentsLoader() {
    let currentPercent = 0;
    const percentTimerId = setInterval(() => {
      currentPercent = currentPercent + 1;
      document.querySelector('#percent').textContent = currentPercent + '%';
      if (currentPercent === 100) {
        clearInterval(percentTimerId);
        currentPercent = 0;
        this.onSuccess();
      }
    }, 100);
    window.timerIds.push(percentTimerId);
  },
  onSuccess() {
    autoSliderIntervalIds.forEach(id => clearInterval(id));
    if (window.agreementButtonIntervalId) {
      clearInterval(window.agreementButtonIntervalId);
    }

    window.agreementButtonIntervalId = setInterval(function () {
      if (window.generateProductSuccess) {
        clearInterval(window.agreementButtonIntervalId);
        window.location.href = window.getHost() + document.querySelector('#processing').dataset.href;
      }
    }, this.CHECK_GENERATE_TIMING);
  },
  onFail() {
    window.timerIds.forEach(id => clearInterval(id));
    autoSliderIntervalIds.forEach(id => clearInterval(id));
    window.fillerAnimation.style.animationPlayState = 'paused';
    window.haloLoader.style.animationPlayState = 'paused';
  },
};

window.timerIds = [];
window.spinningTexts = [];
window.currentActive = 0;
window.textStates = ['active', 'pale'];
window.onFail = loaderAnimate.onFail;

window.onpagehide = function () {
  window.fillerAnimation?.classList.remove('animate-filling');
  window = {};
};

document.addEventListener('DOMContentLoaded', () => {
  loaderAnimate.init();
  return;
});

function handleOnPageShow(restartLoader) {
  const percent = document.querySelector('#percent')?.innerHTML;
  if (sessionStorage.getItem('previousPage') === '/final' && percent === '100%') {
    restartLoader();
    sessionStorage.removeItem('previousPage');
  }
}

window.onpageshow = function () {
  setTimeout(() => {
    handleOnPageShow(restartLoader);
  }, 100);
};

function restartLoader() {
  window.spinningTexts.forEach((e, index) => {
    e.classList.remove(...window.textStates);
    e.classList.add(window.textStates[index]);
  });
  window.currentActive = 0;
  window.slider.style = 'translateX(0px)';
  window.fillerAnimation.classList.remove('animate-filling');
  window.fillerAnimation.classList.add('animate-filling');
  loaderAnimate.init();
}

function refreshDomWindowElements() {
  window.slider = document.querySelector('#processing-text');
  window.spinningTexts = [...document.querySelectorAll('.js-spin-item')];
  window.fillerAnimation = document.querySelector('#fillerAnimation');
  window.haloLoader = document.querySelector('#halo-loader');
}

module.exports = { loaderAnimate, handleOnPageShow };
